export class EncryptionHandler {
  _iv: any
  _params: AesCbcParams
  _key: CryptoKey

  private constructor(
    iv: any,
    params: AesCbcParams
  ) {
    this._iv = iv
    this._params = params
  }

  public static getEncryptor(): EncryptionHandler {
    const iv: any = crypto.getRandomValues(new Uint8Array(16))
    const params = {
      name: 'AES-CBC',
      iv
    }
    return new EncryptionHandler(iv, params)
  }

  public static getDecryptor(iv: Uint8Array): EncryptionHandler {
    const params = {
      name: 'AES-CBC',
      iv
    }
    return new EncryptionHandler(iv, params)
  }

  get params() {
    return this.params
  }

  setIV(iv: Uint8Array) {
    this._iv = iv
    this._params = {
      name: 'AES-CBC',
      iv
    }
  }

  resetIV() {
    const iv: any = crypto.getRandomValues(new Uint8Array(16))
    this._iv = iv
    this._params = {
      name: 'AES-CBC',
      iv
    }
  }

  async setKey(keyString: string) {
    const key: CryptoKey = await crypto.subtle.importKey('raw', this.stringToByteArray(keyString), 'AES-CBC', false, ['encrypt', 'decrypt'])
    this._key = key
  }

  async encryptBlob(blob: Blob): Promise<ArrayBuffer> {
    const blobBuffer: ArrayBuffer = await new Response(blob).arrayBuffer()
    const blobEncrypted: ArrayBuffer = await crypto.subtle.encrypt(this._params, this._key, blobBuffer)

    const tmp: Uint8Array = new Uint8Array(this._iv.byteLength + blobEncrypted.byteLength)
    tmp.set(this._iv, 0)
    tmp.set(new Uint8Array(blobEncrypted), this._iv.byteLength)

    return tmp.buffer
  }

  async decryptBlob(blob: Blob): Promise<ArrayBuffer> {
    const blobBuffer: ArrayBuffer = await new Response(blob).arrayBuffer()
    const blobDecrypted: ArrayBuffer = await crypto.subtle.decrypt(this._params, this._key, blobBuffer)

    return blobDecrypted
  }

  stringToByteArray(value: string): Uint8Array {
    const enc = new TextEncoder()
    return enc.encode(value) // default uft-8
  }
}
